var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"digital-signature-pill",class:`is-${_vm.signature.status}`,attrs:{"title":_vm.signature.error || null}},[_c('fa-icon',{attrs:{"icon":['fal', _vm.icon],"spin":_vm.isRunning}}),_vm._v(" "+_vm._s(_vm.label)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }